import { render, staticRenderFns } from "./JobWorkerAssignment.vue?vue&type=template&id=63225220&scoped=true"
import script from "./JobWorkerAssignment.vue?vue&type=script&lang=js"
export * from "./JobWorkerAssignment.vue?vue&type=script&lang=js"
import style0 from "./JobWorkerAssignment.vue?vue&type=style&index=0&id=63225220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63225220",
  null
  
)

export default component.exports